import { useState } from "react";

import { Check, Copy } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export interface CopyButtonProps {
  textToCopy: string;
}

export const CopyButton = ({ textToCopy }: Readonly<CopyButtonProps>) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      console.log("Text copied to clipboard");
      setCopied(true);
      setTimeout(() => setCopied(false), 5000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          className="-mt-1"
          variant="outline"
          size="sm"
          onClick={handleCopy}
        >
          {copied ? (
            <Check size={12} className="text-green-500" />
          ) : (
            <Copy size={12} />
          )}
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        {copied ? <p>Copied!</p> : <p>Copy to clipboard</p>}
      </TooltipContent>
    </Tooltip>
  );
};
